// extracted by mini-css-extract-plugin
module.exports = {"ForgotPasswordButton":"ForgotPassword_ForgotPasswordButton__3Bqcc","ResetPasswordButton":"ForgotPassword_ResetPasswordButton__3Wvue"};